export const formatDateTime = (dateString: string | undefined) => {
  if (!dateString) return { date: '', time: '' }

  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return { date: '', time: '' }

  return {
    date: date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }),
    time: date
      .toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      .replace(/\s+/g, ' '), // Remove any extra spaces
  }
}

/**
 * Formats a date string or Date object to a full datetime string.
 * Example output: "Tuesday, January 20, 2026 at 5:56 PM PST"
 */
export const formatFullDateTime = (date: Date | string): string => {
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return ''

  return d.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  })
}

/**
 * Formats a date to date-only string: MM/DD/YYYY
 */
export const formatDateOnly = (date: Date | string): string => {
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return ''

  return d.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
}

/**
 * Formats a date to time-only string: HH:MMam/pm
 */
export const formatTimeOnly = (date: Date | string): string => {
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return ''

  return d
    .toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase()
}
